import styled from "styled-components";
import { Heading6, Paragraph2 } from "../../../components";

export const SectionParagraph = styled(Paragraph2)`
  font-weight: 700;
`;

export const ModalHeaderWrapper = styled(Heading6)`
  font-size: 20px;
`;
